import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store/profile';
import { cn } from '@shared/utils';
import { UserType, UserWithPaymentInfo, type AccountResponse, type CardResponse } from '@shared/api';
import { UserLongInfoItem } from './userLongInfoItem';

interface UserLongInfoProps {
  className?: string;
  open: boolean;
  user: UserWithPaymentInfo;
  accounts: AccountResponse[];
  cards: CardResponse[];
}

export const UserLongInfo = (props: UserLongInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  if (props.user.userType === UserType.Admin || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;
  return (
    <div className={cn(props.user.locked && 'pointer-events-none select-none opacity-50', props.className)}>
      <UserLongInfoItem show={props.open} user={props.user} accounts={props.accounts} cards={props.cards} />
    </div>
  );
};
